import React, { useState, useEffect } from 'react';

const Menu = () => {
  const [soldOutItems, setSoldOutItems] = useState([]);

  useEffect(() => {
    window.getSoldoutItem = ({ soldOut }) => {
      setSoldOutItems(soldOut);
    };
  }, []);

  return (
    <div style={{
      position: 'relative',
      width: '100vw',
      height: '100vh',
      backgroundImage: 'url("res/menu.png")',
      backgroundPosition: 'center center',
      backgroundSize: 'contain', // 保持圖片比例並使整個圖片都能被完整顯示
      backgroundRepeat: 'no-repeat'
    }}>

      {soldOutItems.map((item, index) => (
        <img
          key={index}
          src={`res/items/${item}.png`}
          alt={item}
          style={{
            position: 'absolute', /* 绝对定位 */
            top: '50%', /* 顶部距离容器的50% */
            left: '50%', /* 左侧距离容器的50% */
            transform: 'translate(-50%, -50%)', /* 使用 transform 将图片中心对齐至容器中心 */
            maxWidth: '100%', /* 最大宽度为容器的100%，确保图片不会超出容器 */
            maxHeight: '100%', /* 最大高度为容器的100%，确保图片不会超出容器 */
            // objectFit: 'cover',
            // left: '50%',
            // top: '50%',
            // transform: 'translate(-50%, -50%)'
          }}
        />
      ))}
    </div>
  );
};

export default Menu;
